import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation ,useNavigate} from "react-router-dom";
import Pagination from "./Pagination";
import { useDispatch, useSelector } from "react-redux";
import { UpdateStatusTerm } from "../redux/slices/Filters/StatusSlice";
import { UpdateStatusAPI } from "../redux/actions/User/Detail/UpdateStatusAction";
import { updateStatusStateReset } from "../redux/slices/User/UpdateStatusSlice";
import { showErrorToast, showSuccessToast } from "../helpers/SweetAlert";
import { EditNewsAndEventsAPI } from "../redux/actions/NewsAndEvents/EditNewsAndEventsAction";
import { editNewsAndEventsStateReset } from "../redux/slices/NewsAndEvents/EditNewsAndEventsSlice";
import Swal from "sweetalert2";
import { DeleteProductAPI } from '../redux/actions/Product/DeleteProductAction';
import {DeleteMenuAPI} from '../redux/actions/Menu/DeleteMenuAction';
import {DeleteFoodCategoryAPI} from '../redux/actions/Content/DeleteFoodCategoryAction';
import { deleteProductStateReset } from "../redux/slices/Product/DeleteProductSlice";
import { DeleteQueryAPI } from "../redux/actions/Queries/DeleteQueryAction";
import { DeleteReportsAPI } from "../redux/actions/Queries/DeleteReportsAction";
import { deleteQueryStateReset } from "../redux/slices/Query/DeleteQuerySlice";
import { deleteReportsStateReset } from "../redux/slices/Query/DeleteReportsSlice";
import { DeleteNewsAndEventsAPI } from "../redux/actions/NewsAndEvents/DeleteNewsAndEventsAction";
import { deleteNewsAndEventsStateReset } from "../redux/slices/NewsAndEvents/DeleteNewsAndEventsSlice";
import { deleteMenuStateReset } from "../redux/slices/Menu/DeleteMenuSlice";
import { deleteFoodCategoriesStateReset } from "../redux/slices/Content/DeleteFoodCategoriesSlice"; // New import

function usePrevious(value) {
    const ref = useRef();

    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

const Table = ({ title, tableData, columns, items, limit, setIsToggled, setDeleted,setDeletedMenu, totalPages, currentPage, handlePageChange, activeTab, role, statusTerm, fetchNewsAndEvents, tab, setDeletedQuery, setDeletedNewsAndEvents, setDeletedReports,setDeletedFoodCategories,handleEditClick }) => {
    
    const dispatch = useDispatch();
    const location = useLocation();
    const prevPathname = usePrevious(location.pathname);
    // const prevTab = usePrevious(tab);
    // const activityStatus = useSelector((state) => state.status.term)
    const { response: updateStatusResponse, error: updateStatusError } = useSelector((state) => state.updateUserStatus);
    const { response: editNewsAndEventsResponse, error: editNewsAndEventsError } = useSelector((state) => state.editNewsAndEvents);
    const { response: deleteProductResponse, error: deleteProductError } = useSelector((state) => state.deleteProduct);
    const { response: deleteNewsAndEventsResponse, error: deleteNewsAndEventsError } = useSelector((state) => state.deleteQuery);
    const { response: deleteMenuResponse, error: deleteMenuError } = useSelector((state) => state.deleteMenu);
    const { response: deleteQueryResponse, error: deleteQueryError } = useSelector((state) => state.deleteQuery);
    const { response: deleteReportsResponse, error: deleteReportsError } = useSelector((state) => state.deleteReports);
   const { response: deleteFoodCategoryResponse, error: deleteFoodCategoryError } = useSelector((state) => state.deleteFoodCategory);
    const [dataList, setDataList] = useState(tableData?.list || []);
    const [localStatus, setLocalStatus] = useState(statusTerm);

    const [updatedTitle, setUpdatedTitle] = useState('');
    const [description, setDescription] = useState('');
    const [editNewsItem, setEditNewsItem] = React.useState(null);
    const [validationErrors, setValidationErrors] = useState('');

    const handleStatusChange = (e) => {
        const value = e.target.value;
        setLocalStatus(value);         // Update local first
        handlePageChange(1);             // Reset page immediately
    };

    
    const handleDelete = useCallback(async (d) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to delete`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    if (location.pathname === '/admin-dashboard/product-management') {
                        await dispatch(DeleteProductAPI(d._id));
                    }
                    else if (location.pathname === '/admin-dashboard/menu-management') {
                        await dispatch(DeleteMenuAPI (d._id));
                    }
                    else if (location.pathname === '/admin-dashboard/content-management' && tab === 'foodCategories') {
                        await dispatch(DeleteFoodCategoryAPI(d._id));
                    }
                    else if (location.pathname === '/admin-dashboard/news-and-events-management') {
                        await dispatch(DeleteNewsAndEventsAPI(d._id));
                    }
                    else if (location.pathname === '/admin-dashboard/queries-management' && tab === 'contact') {
                        await dispatch(DeleteQueryAPI(d._id));
                    }
                    else if (location.pathname === '/admin-dashboard/queries-management' && tab === 'reports') {
                        await dispatch(DeleteReportsAPI(d._id));
                    }

                } catch (error) {
                    Swal.fire(error?.response?.message);
                }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire('Cancelled');
            }
        });
    }, [dispatch]);

    // useEffect(() => {
    //     if (prevTab && prevTab !== tab) {
    //         dispatch(UpdateStatusTerm(''));
    //     }
    // }, [tab, prevTab]);

    const toggleStatus = useCallback(async (data) => {
        const newStatus = data.status === 'Active' || data.status === 0 || data.status === '0' ? 1 : 0;

        try {
            await dispatch(UpdateStatusAPI({ id: data._id, status: newStatus }));
            setDataList((prevList) =>
                prevList.map((item) => {
                    return item._id === data._id ? { ...item, status: newStatus } : item
                }
                )
            );
            setIsToggled(true)
        } catch (error) {
            console.error('Error toggling status:', error);
        }
    }, [dispatch]);
   
    const renderRow = (row) => {

        return columns?.map((col, colIndex) => {
            switch (col) {
                case 'Customer Name':
                    return <td key={colIndex}>{row?.firstName || 'N/A'}</td>;
                case 'Supplier Name':
                    return <td key={colIndex}>{row?.firstName || 'N/A'}</td>;
                case 'Food Name':
                    return <td key={colIndex}>{row?.name || 'N/A'}</td>;
                case 'Price':
                    return <td key={colIndex}>{row?.price || 'N/A'}</td>;
                case 'Restaurants Name':
                    return <td key={colIndex}>{row?.firstName || 'N/A'}</td>;
                case 'Product Name':
                    return <td key={colIndex}>{row?.name || 'N/A'}</td>;
                case 'Food Type':
                    return <td key={colIndex}>{row?.category || 0}</td>;
                case 'Day':
                    return <td key={colIndex}>{row?.day || 0}</td>;
                case 'Type':
                    return <td key={colIndex}>{row?.productType || 'N/A'}</td>;
                case 'Title':
                    return <td key={colIndex}>{row?.title || 'N/A'}</td>;
                // case 'Type':
                //     return <td key={colIndex}>{row?.name || 'N/A'}</td>;
                case 'Description':
                    return <td key={colIndex}>{row?.description || 'N/A'}</td>;
                case 'Category Name':
                    return <td key={colIndex}>{row?.name || 'N/A'}</td>;
                case 'Food Category Name':
                       return <td key={colIndex}>{row?.foodCategoryName || row?.name || 'N/A'}</td>;
                case 'Total Purchases':
                    return <td key={colIndex}>
                        {row?.orderRequestCount || 0}
                    </td>;
                case 'Total Product':
                    return <td key={colIndex}>
                        {row?.productCount || 0}
                    </td>;
                case 'Delivery Date':
                    return <td key={colIndex}>
                        {row?.scheduledDate || '- - -'}
                    </td>;
                case 'Total Products Ordered':
                    return <td key={colIndex}>
                        {row?.requestedProductCount || 0}
                    </td>;
                case 'Name':
                    return <td key={colIndex}>
                        {row?.userFirstName || row?.unitName || row?.userId?.firstName || 'N/A'}
                    </td>;
                case 'User Type':
                    return <td key={colIndex}>
                        {row?.userId?.role || 'N/A'}
                    </td>;
                case 'Units':
                    return <td key={colIndex}>
                        {row?.units && row?.units?.length > 0 ? (
                            row?.units.join(', ')
                        ) : (
                            "No units"
                        )}
                    </td>;
                case 'Country':
                    return <td key={colIndex}>{row?.country || 'N/A'}</td>;
                case 'Email':
                    return <td key={colIndex}>{row?.email || row?.userId?.email || 'N/A'}</td>;
                case 'Status':
                    // { location.pathname !== '/admin-dahsboard/order-managemnet' ? }
                    // const isActive = row?.status == 'Active' || row?.status == 0;
                    // const displayStatus = row?.status == 'Active' || row?.status == 'Inactive'
                    //     ? row?.status
                    //     : row?.status == 0
                    //         ? 'Active'
                    //         : row?.status == 1
                    //             ? 'Inactive'
                    //             : 'N/A';
                    // return <td key={colIndex}><span className={`table-status ${isActive ? 'st-active' : 'st-inactive'}`}>
                    //     {displayStatus}
                    // </span></td >;
                    {
                        if (location.pathname !== '/admin-dashboard/order-management') {
                            const isActive = row?.status === 'Active' || row?.status === 0 || row?.status === '0';
                            const displayStatus =
                                row?.status === 'Active' || row?.status === 'Inactive'
                                    ? row?.status
                                    : row?.status === 0
                                        ? 'Active'
                                        : row?.status === '0'
                                            ? 'Active'
                                            : row?.status === 1 ?
                                                'Inactive' :
                                                row?.status === '1' ?
                                                    'Inactive' : 'N/A'
                            return (
                                <td key={colIndex}>
                                    <span className={`table-status ${isActive ? 'st-active' : 'st-inactive'}`}>
                                        {displayStatus}
                                    </span>
                                </td>
                            );
                        } else {
                            let orderStatus = '';
                            let statusClass = '';
                            if (row?.status == '0' || row?.status == '7') {
                                orderStatus = 'Pending'
                                statusClass = 'st-pending'
                            }
                            else if (row?.status == '1') {
                                orderStatus = 'Accepted'
                                statusClass = 'st-accepted'
                            }
                            else if (row?.status == '2') {
                                orderStatus = 'Rejected'
                                statusClass = 'st-rejected'
                            }
                            else if (row?.status == '3') {
                                orderStatus = 'Cancelled'
                                statusClass = 'st-cancelled'
                            }
                            else if (row?.status == '4') {
                                orderStatus = 'Payment Pending'
                                statusClass = 'st-payment-pending'
                            }
                            else if (row?.status == '5') {
                                orderStatus = 'Completed'
                                statusClass = 'st-completed'
                            }
                            else if (row?.status == '6') {
                                orderStatus = 'Reported'
                                statusClass = 'st-reported'
                            }
                            return <td key={colIndex}>
                                <span className={`table-status ${statusClass}`}>
                                    {orderStatus}
                                </span>
                            </td>
                        }
                    }

                case 'Action':
                    return (
                        <td key={colIndex}>
                            <span className="table-action">
                                {(location.pathname !== '/admin-dashboard/product-management' && location.pathname !== '/admin-dashboard/menu-management' && location.pathname !== '/admin-dashboard/queries-management' && (location.pathname !== '/admin-dashboard/content-management' || activeTab == 'categories' || activeTab == 'foodCategories'|| activeTab == 'productTypes' || activeTab == 'units')) &&
                                    < Link to={
                                        location.pathname === '/admin-dashboard/suppliers-management'
                                            ? `/admin-dashboard/supplier-detail/${row?._id}`

                                            : location.pathname === '/admin-dashboard/order-management'
                                                ? role == 'restaurant'
                                                    ? `/admin-dashboard/order-detail/${role}/${row?._id}`
                                                    : role == 'customer'
                                                        ? `/admin-dashboard/order-detail/${role}/${row?._id}`
                                                        : role == 'supplier'
                                                            ? `/admin-dashboard/order-detail/${role}/${row?._id}`
                                                            : '#'
                                                : location.pathname === '/admin-dashboard/customer-management' ? `/admin-dashboard/customer-detail/${row?._id}`
                                                    : location.pathname === '/admin-dashboard/restaurants-management'
                                                        ? `/admin-dashboard/restaurant-detail/${row?._id}`
                                                        : location.pathname === '/admin-dashboard/news-and-events-management' ? `/admin-dashboard/news-and-events/${row?._id}`
                                                            : '#'
                                    } className="table-eye">
                                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M11.9998 20.2702C15.5298 20.2702 18.8198 18.1902 21.1098 14.5902C22.0098 13.1802 22.0098 10.8102 21.1098 9.40021C18.8198 5.80021 15.5298 3.72021 11.9998 3.72021C8.46984 3.72021 5.17984 5.80021 2.88984 9.40021C1.98984 10.8102 1.98984 13.1802 2.88984 14.5902C5.17984 18.1902 8.46984 20.2702 11.9998 20.2702Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </Link>
                                }
                                {(location.pathname !== '/admin-dashboard/order-management' && location.pathname !== '/admin-dashboard/suppliers-management' && location.pathname !== '/admin-dashboard/restaurants-management' && (location.pathname !== '/admin-dashboard/content-management' || tab == 'foodCategories')) &&
                                    <button className="table-trash" onClick={() => handleDelete(row)} disabled={(row?.status == 'Active' || row?.status == 0) && location.pathname === '/admin-dashboard/queries-management'} // Disable button if status is "active"
                                        style={{ cursor: (row?.status == 'Active' || row?.status == 0) && location.pathname === '/admin-dashboard/queries-management' ? 'not-allowed' : 'pointer', opacity: (row?.status == 'Active' || row?.status == 0) && location.pathname === '/admin-dashboard/queries-management' ? 0.5 : 1 }}>
                                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M18.8504 9.14014L18.2004 19.2101C18.0904 20.7801 18.0004 22.0001 15.2104 22.0001H8.79039C6.00039 22.0001 5.91039 20.7801 5.80039 19.2101L5.15039 9.14014" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M10.3301 16.5H13.6601" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M9.5 12.5H14.5" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>}
                                {location.pathname !== '/admin-dashboard/order-management' && location.pathname !== '/admin-dashboard/menu-management' &&
                                    <span className="table-check">

                                        <input
                                            type="checkbox"
                                            checked={row?.status === 0}
                                            id={row?._id}
                                            onChange={() => toggleStatus(row)}
                                        />
                                        <label htmlFor={row?._id} />
                                    </span>}
                                    {/* {location.pathname === '/admin-dashboard/content-management' && (
                                        <button 
                                            type="button" 
                                            className="table-edit" 
                                            data-bs-toggle="modal" 
                                            data-bs-target="#editCategoryModal" 
                                            onClick={() => handleEditClick(row)}
                                        >
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.2594 3.60022L5.04936 12.2902C4.73936 12.6202 4.43936 13.2702 4.37936 13.7202L4.00936 16.9602C3.87936 18.1302 4.71936 18.9302 5.87936 18.7302L9.09936 18.1802C9.54936 18.1002 10.1794 17.7702 10.4894 17.4302L18.6994 8.74022C20.1194 7.24022 20.7594 5.53022 18.5494 3.44022C16.3494 1.37022 14.6794 2.10022 13.2594 3.60022Z" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M11.8906 5.0498C12.3206 7.8098 14.5606 9.9198 17.3406 10.1998" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M3 22H21" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </button>
                                        )} */}
                                {
                                    location.pathname === '/admin-dashboard/news-and-events-management' &&
                                    <button type="button" className="table-edit" data-bs-toggle="modal" data-bs-target="#editNewsAndEventsModal" onClick={() => handleEditClicks(row)}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.2594 3.60022L5.04936 12.2902C4.73936 12.6202 4.43936 13.2702 4.37936 13.7202L4.00936 16.9602C3.87936 18.1302 4.71936 18.9302 5.87936 18.7302L9.09936 18.1802C9.54936 18.1002 10.1794 17.7702 10.4894 17.4302L18.6994 8.74022C20.1194 7.24022 20.7594 5.53022 18.5494 3.44022C16.3494 1.37022 14.6794 2.10022 13.2594 3.60022Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M11.8906 5.0498C12.3206 7.8098 14.5606 9.9198 17.3406 10.1998" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M3 22H21" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </button>
                                }
                                {/* {location.pathname === '/admin-dashboard/content-management' && tab === 'foodCategories' && (
                                <button 
                                    type="button" 
                                    className="table-edit" 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#editFoodCategoryModal" 
                                    onClick={() => handleEditClick(row)}
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.2594 3.60022L5.04936 12.2902C4.73936 12.6202 4.43936 13.2702 4.37936 13.7202L4.00936 16.9602C3.87936 18.1302 4.71936 18.9302 5.87936 18.7302L9.09936 18.1802C9.54936 18.1002 10.1794 17.7702 10.4894 17.4302L18.6994 8.74022C20.1194 7.24022 20.7594 5.53022 18.5494 3.44022C16.3494 1.37022 14.6794 2.10022 13.2594 3.60022Z" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M11.8906 5.0498C12.3206 7.8098 14.5606 9.9198 17.3406 10.1998" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M3 22H21" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            )} */}
                                 {
                                    location.pathname === '/admin-dashboard/menu-management' &&
                                    <button type="button" className="table-edit" onClick={() => navigate(`/admin-dashboard/menu-management/${row._id}`)}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.2594 3.60022L5.04936 12.2902C4.73936 12.6202 4.43936 13.2702 4.37936 13.7202L4.00936 16.9602C3.87936 18.1302 4.71936 18.9302 5.87936 18.7302L9.09936 18.1802C9.54936 18.1002 10.1794 17.7702 10.4894 17.4302L18.6994 8.74022C20.1194 7.24022 20.7594 5.53022 18.5494 3.44022C16.3494 1.37022 14.6794 2.10022 13.2594 3.60022Z" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M11.8906 5.0498C12.3206 7.8098 14.5606 9.9198 17.3406 10.1998" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M3 22H21" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </button>
                                }
                            </span>
                        </td >
                    );
                default:
                    return <td key={colIndex}>N/A</td>;
            }
        });
    };
    

    const validateForm = () => {
        const newErrors = {};
        if (!updatedTitle.trim()) newErrors.updatedTitle = true;
        if (!description.trim()) newErrors.description = true;
        setValidationErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleEditClicks = (row) => {
        setEditNewsItem(row);       // Save full row to state
        setUpdatedTitle(row?.title || '');  // Pre-fill title state
        setDescription(row?.description || ''); // Pre-fill description state
        // ... similarly prefill other fields as needed
    };
    const navigate = useNavigate();

    const handleSubmit = async () => {
        if (!validateForm()) return;

        const payload = {
            id: editNewsItem?._id,
            title: updatedTitle,
            description: description,
            // Add more fields if needed
        };

        try {

            await dispatch(EditNewsAndEventsAPI(payload));
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    }
    // useEffect(() => {
    //     return () => {
    //         dispatch(UpdateStatusTerm(''));
    //     };
    // }, []);
    useEffect(() => {
        setDataList(tableData?.list || []);
    }, [tableData?.list]);

    // useEffect(() => {
    //     if (prevPathname && prevPathname !== location.pathname) {
    //         dispatch(UpdateStatusTerm(''));
    //     }
    //     // dispatch(UpdateStatusTerm(''));
    // }, [location.pathname]);


    useEffect(() => {
        dispatch(UpdateStatusTerm(localStatus));
    }, [localStatus, dispatch]);

    useEffect(() => {
        if (deleteProductResponse?.status === true) {
            Swal.fire(deleteProductResponse.message);
            dispatch(deleteProductStateReset());
            setDeleted(true);
        }
        if (deleteProductError) {
            Swal.fire(deleteProductError.data);
            dispatch(deleteProductStateReset());
        }

    }, [deleteProductResponse, deleteProductError])

    useEffect(() => {
  if (deleteFoodCategoryResponse?.status === true) {
    Swal.fire(deleteFoodCategoryResponse.message);
    setDataList((prevList) => prevList.filter((item) => item._id !== deleteFoodCategoryResponse.data?.id));
    dispatch(deleteFoodCategoriesStateReset());
    setDeletedFoodCategories(true);
  }
  // ...
}, [deleteFoodCategoryResponse, deleteFoodCategoryError, setDeletedFoodCategories]);

    useEffect(() => {
    if (deleteMenuResponse?.status === true) {
        Swal.fire(deleteMenuResponse.message);
        dispatch(deleteMenuStateReset());
        setDeletedMenu(true)
    }
    if (deleteMenuError) {
        Swal.fire(deleteMenuError.data);
        dispatch(deleteMenuStateReset()); 
    }
}, [deleteMenuResponse, deleteMenuError]);


    useEffect(() => {
        if (deleteQueryResponse?.status === true) {
            Swal.fire(deleteQueryResponse.message);
            dispatch(deleteQueryStateReset());
            setDeletedQuery(true);
        }
        if (deleteQueryError) {
            Swal.fire(deleteQueryError.data);
            dispatch(deleteQueryStateReset());
        }

    }, [deleteQueryResponse, deleteQueryError])

    useEffect(() => {
        if (deleteReportsResponse?.status === true) {
            Swal.fire(deleteReportsResponse.message);
            dispatch(deleteReportsStateReset());
            setDeletedReports(true);
        }
        if (deleteReportsError) {
            Swal.fire(deleteReportsError.data);
            dispatch(deleteReportsStateReset());
        }

    }, [deleteReportsResponse, deleteReportsError])

    useEffect(() => {
        if (deleteNewsAndEventsResponse?.status === true) {
            Swal.fire(deleteNewsAndEventsResponse.message);
            dispatch(deleteNewsAndEventsStateReset());
            setDeletedNewsAndEvents(true);
        }
        if (deleteNewsAndEventsError) {
            Swal.fire(deleteNewsAndEventsError.data);
            dispatch(deleteNewsAndEventsStateReset());
        }

    }, [deleteNewsAndEventsResponse, deleteNewsAndEventsError])

    useEffect(() => {
        if (updateStatusResponse?.status === true) {
            showSuccessToast(updateStatusResponse?.message);
            dispatch(updateStatusStateReset());
        }
        if (updateStatusError) {
            showErrorToast(updateStatusError?.data);
            dispatch(updateStatusStateReset());
        }
    }, [updateStatusResponse, updateStatusError])

    useEffect(() => {
        if (editNewsAndEventsResponse?.status === true) {
            showSuccessToast(editNewsAndEventsResponse?.message);
            dispatch(editNewsAndEventsStateReset());
            const modalElement = document.getElementById('editNewsAndEventsModal');
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) {
                modal.hide();

            } else {
                const newModal = new window.bootstrap.Modal(modalElement);
                newModal.hide();
            };
            fetchNewsAndEvents();
        }
    }, [editNewsAndEventsResponse, fetchNewsAndEvents, dispatch])

    useEffect(() => {
        if (editNewsAndEventsError) {
            showErrorToast(editNewsAndEventsError?.data);
            dispatch(editNewsAndEventsStateReset())
        }
    }, [editNewsAndEventsError])

    return (
        <div className={`table_wrapper_card ${activeTab === 'categories' || activeTab === 'foodCategories' || activeTab === 'productTypes' ? 'no-padding' : ''
            }`}>
            <div className="container">
                <div className="row gy-3">
                    <div className="col-xl-12">
                        <div className="sub-heading flex-box flex-wrap gap-3 mb-0">
                            <div>
                                <h2>{`${title} Listing`}</h2>
                            </div>
                            <div className="side-content">
                                {location.pathname !== '/admin-dashboard/content-management' && location.pathname !== '/admin-dashboard/menu-management' && location.pathname !== '/admin-dashboard/order-management' && location.pathname !== '/admin-dashboard/queries-management' &&
                                    < div >
                                        <select
                                            className="form-select"
                                            value={localStatus}
                                            onChange={handleStatusChange}
                                        >
                                            <option value="">Status</option>
                                            <option value="0">Active</option>
                                            <option value="1">Inactive</option>
                                        </select>
                                    </div>}
                            </div>
                        </div>
                        <div className="table-blk table-responsive">
                            <table className="table border-0 mb-0">
                                <thead>
                                    <tr>
                                        {columns?.map((col, index) => (
                                            <th key={index}>{col}</th>
                                        ))}
                                    </tr>
                                </thead>

                                <tbody>
                                    {Array.isArray(dataList) && dataList.length > 0 ? (
                                        dataList?.map((row, index) => (
                                            <tr key={index}>
                                                {renderRow(row)}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="100%" style={{ textAlign: 'center' }}>No data available</td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>
                        <Pagination currentPage={currentPage} totalPages={totalPages} items={items} limit={limit} handlePageChange={handlePageChange} />
                    </div>
                </div >
            </div >


            {/* edit modal */}
            < div className="modal fade" id="editNewsAndEventsModal" tabIndex={- 1} aria-labelledby="editNewsAndEventsModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-2 fw-bold text-black" id="detailModalLabel">Edit</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body detail-modal-body">
                            <div className='modal-field mb-2'>
                                <div className="input_wrapper">
                                    <label>Title</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.updatedTitle ? 'is-invalid' : ''}`} placeholder="Enter title" value={updatedTitle} onChange={(e) => {
                                            const value = e.target.value;
                                            if (value.length === 1 && value === ' ') return;
                                            setUpdatedTitle(value);
                                            if (validationErrors.updatedTitle) {
                                                setValidationErrors(prev => ({ ...prev, updatedTitle: false }));
                                            }
                                        }} />
                                    </div>
                                </div>
                                <div className="input_wrapper">
                                    <label>Description</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.description ? 'is-invalid' : ''}`} placeholder="Enter description" value={description} onChange={(e) => {
                                            const value = e.target.value;
                                            if (value.length === 1 && value === ' ') return;
                                            setDescription(value);
                                            if (validationErrors.description) {
                                                setValidationErrors(prev => ({ ...prev, description: false }));
                                            }
                                        }} />
                                    </div>
                                </div>

                                <div className='modal_btn d-flex justify-content-end gap-2 p-0 mt-4'>
                                    {/* <button className='transparent-btn fs-14 py-2' onClick={resetFormFields}>Cancel</button> */}
                                    <button className='primary-btn fs-14 py-2' onClick={handleSubmit}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            {/* <-------> */}
        </div >
    )
}

export default Table